import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';

router.afterEach((to) => {
	if (localStorage.getItem("cookie-show-key") == 1 && typeof window.ym === 'function') {
		window.ym(98918167, 'hit', to.fullPath);
	}
});

createApp(App)
	.use(Antd)
	.use(store)
	.use(router)
	.mount('#vapp')
